// extracted by mini-css-extract-plugin
export default {"container":"w0-z","list":"x0-z"};